/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import borders from 'src/assets/md-theme/base/borders';
import colors from 'src/assets/md-theme/base/colors';

const { borderWidth } = borders;
const { light, grey } = colors;

// types
type Types = any;

const tableRow: Types = {
  styleOverrides: {
    root: {
      borderBottom: `${borderWidth[1]} solid ${light.main}`,
      transition: 'background-color 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: `${grey[50]}`, // Equivalent to hover:bg-muted/50
      },
      '&:last-child': {
        borderBottom: 0,
        '& td': {
          borderBottom: 0,
        },
      },
      '&[data-state="selected"]': {
        backgroundColor: `${grey[100]}`, // Equivalent to data-[state=selected]:bg-muted
      },
    },
  },
};

export default tableRow;
